import { render } from "./XIconSolidCirclePause.vue?vue&type=template&id=59283881"
import script from "./XIconSolidCirclePause.vue?vue&type=script&lang=js"
export * from "./XIconSolidCirclePause.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidCirclePause.vue"]])

export default __exports__